const initializeCountryOptionsWithMarketoOptions = require("./initializeCountryOptionsWithMarketoOptions");

/**
 * @return {Promise<void>}
 */
module.exports = async function initializeAllCountryOptionsWithMarketoOptions() {
    const countrySelects = document.querySelectorAll('[data-component="country-select"]');

    for (let countrySelect of countrySelects) {
        if (countrySelect instanceof HTMLSelectElement) {
            await initializeCountryOptionsWithMarketoOptions(countrySelect);
        }
    }
}